// @flow
import RoofSnapSearchApiClient from 'roofsnap-search-api-client';
import {
    GET_SEARCH_SKETCH_ORDERS_REQUEST,
    GET_SEARCH_SKETCH_ORDERS_SUCCESS,
    GET_SEARCH_SKETCH_ORDERS_FAILURE,
} from './actionTypes';
import { CALL_API } from "../middleware/api";
import LocalStorageWrapper from "../lib/localStorageWrapper";

export const searchSketchOrders = (search: string, page: number = 1) => {
    const accessToken = LocalStorageWrapper.getItem('accessToken');
    const apiClientInit = {
        token: accessToken,
        environment: process.env.REACT_APP_ENVIRONMENT,
        apiVersion: '2017-11-11',
    };
    const roofSnapSearchClient = new RoofSnapSearchApiClient(apiClientInit);
    const request: Function = roofSnapSearchClient.search;

    return {
        [CALL_API]: {
            types: [
                GET_SEARCH_SKETCH_ORDERS_REQUEST,
                GET_SEARCH_SKETCH_ORDERS_SUCCESS,
                GET_SEARCH_SKETCH_ORDERS_FAILURE,
            ],
            request,
            params: {
                endpoint: "sketchorders",
                search: search,
                page,
            }
        }
    }
};
